// Core
import { useState } from 'react';
import { useQuery } from 'react-query';
import { Box, Button, Grid, Skeleton, useColorMode } from '@chakra-ui/react';

// Assets
import { apiService } from 'services/ApiService';
import { validateLoadMore } from 'services/Utils';

// Components
import Giveaways from '../../../../Giveaways/components/Giveaway';

const UpcomingCancelling = ({ userData }) => {
    const limit = 3;
    const [data, setData] = useState([]);

    const { colorMode } = useColorMode();
    const isDark = colorMode === 'dark';

    const { isLoading } = useQuery({
        queryKey: ['upcoming-cancelling'],
        queryFn: async () => {
            const response = await apiService.getGiveaways({ limit, status: 'active' });
            setData(response.data);
            return true;
        },
        refetchOnWindowFocus: false,
        retry: false
    });

    return (
    	<>
        { isLoading && data.length === 0 ? ( 
            <Grid mt={{base: '21px', md: '40px'}} templateColumns={{ base: '1fr', md: '1fr 1fr', lg: '1fr 1fr 1fr' }} gap="24px" templateRows='1fr'>
                <Skeleton borderRadius="16px" h="200px" />
                <Skeleton borderRadius="16px" h="200px" />
                <Skeleton borderRadius="16px" h="200px" />
            </Grid>
        ) : !isLoading && data.length === 0 ? 
            (<></>) : (
            <>
    	        <Grid mt={{base: '21px', md: '40px'}} templateColumns={{ base: '1fr', md: '1fr 1fr', lg: '1fr 1fr 1fr' }} gap="24px" templateRows='1fr'>
    			    { data?.map((item, index) => (
    			        <Giveaways key={index} item={item} type="upcoming-cancelling" userData={userData} />
    			    ))}	
    	        </Grid>
            </>
	    )}
	    </>
    );
};


export default UpcomingCancelling;